import defaultLang from 'antd/es/locale/default';
import {Locale} from "antd/es/locale-provider";
import {PickerLocale as DatePickerLocale} from "antd/es/date-picker/generatePicker";

import uz from "dayjs/locale/uz-latn";

const getDatePicker = (): DatePickerLocale | undefined => {
    if (defaultLang.DatePicker !== undefined) {
        return {
            dateFormat: "DD.MM.YYYY",
            lang: {
                ...defaultLang.DatePicker.lang,
                dateFormat: "DD.MM.YYYY",
                locale: "uz-Latn-UZ",
                today:'Bugun',
                dateTimeFormat:"DD.MM.YYYY HH:mm:ss",
                monthFormat:"MMM",
                placeholder:'Tarix',
                shortMonths: uz.monthsShort,
                shortWeekDays:uz.weekdaysShort,
                now:'Hozir'

            },
            dateTimeFormat:"DD.MM.YYYY HH:mm:ss",
            timePickerLocale: {
                placeholder: 'Vaqt',

            },
            weekFormat: defaultLang.DatePicker.weekFormat,
            monthFormat: defaultLang.DatePicker.monthFormat,
        }
    } else {
        return undefined;
    }

}
const uzLatnUZ: Locale = {
    ...defaultLang,
    locale: "uz-Latn-UZ",
    DatePicker: getDatePicker(),

}
export default uzLatnUZ;